import type React from 'react';
import { Box } from '@nimbus-ds/components';
import { Country, CurrencyType, PaymentResponseDto } from '@tiendanube/common';
import PaymentDetailsTitle from './PaymentDetailsTitle';
import PaymentMethodDetail from './PaymentMethodDetail';

interface PaymentDetailsProps {
  payments: PaymentResponseDto[];
  currency: CurrencyType;
  openGatewayLink: (gatewayLink: string) => void;
  isNuvemPagoPayment: boolean;
  onNuvemPagoRedirect: () => void;
  country: Country;
  isMobile: boolean;
  openNuvemPago: () => void;
  origin: string;
}

function PaymentDetails({
  payments,
  currency,
  openGatewayLink,
  isNuvemPagoPayment,
  onNuvemPagoRedirect,
  country,
  isMobile,
  openNuvemPago,
  origin,
}: Readonly<PaymentDetailsProps>): React.JSX.Element {
  const isMultiplePayments = payments.length > 1;

  return (
    <Box marginTop="2">
      <PaymentDetailsTitle origin={origin} />
      <Box display="flex" flexDirection="column" gap="4">
        {payments.map((payment) => {
          const stableKey = payment.gatewayId
            ? `${payment.gatewayId}-${payment.createdAt}`
            : `${payment.gateway}-${payment.createdAt}`;
          return (
            <PaymentMethodDetail
              key={stableKey}
              payment={payment}
              currency={currency}
              openGatewayLink={openGatewayLink}
              isMultiplePayments={isMultiplePayments}
              isNuvemPagoPayment={isNuvemPagoPayment}
              onNuvemPagoRedirect={onNuvemPagoRedirect}
              country={country}
              isMobile={isMobile}
              openNuvemPago={openNuvemPago}
              origin={origin}
            />
          );
        })}
      </Box>
    </Box>
  );
}

export default PaymentDetails;
